import type { getCurrentLocale } from 'src/helper/helper';
import { getRelativeValue } from 'src/components/dashboard/DashboardPage/helper';

export interface OrgUnitResponseRate {
  label: string;
  invitees: number;
  respondents: number;
}

export const convertApiOrgUnitToOrgUnit = ({
  label,
  stacks,
}: {
  stacks: Array<{
    stackLabel: string;
    value: number;
  }>;
  label: string;
}): OrgUnitResponseRate => ({
  label,
  invitees: stacks.find((stack) => stack.stackLabel === 'invitees')?.value ?? 0,
  respondents:
    stacks.find((stack) => stack.stackLabel === 'respondents')?.value ?? 0,
});

export const getResponseRateForOrgUnit = (
  orgUnit: OrgUnitResponseRate,
  locale: ReturnType<typeof getCurrentLocale>,
): string =>
  orgUnit.invitees === 0
    ? '0'
    : getRelativeValue(orgUnit.respondents, orgUnit.invitees, 0).toLocaleString(
        locale,
      );
